import React from 'react'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  statuses: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',

    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  },
}))

export default function StatusesContainer({ children }) {
  const classes = useStyles()

  return <div className={classes.statuses}>{children}</div>
}
